import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { Snippet } from 'ui/icons';
import { ContentModals, useModalContext } from 'utils/contexts/modal';

import { displayContent } from '../content';

export const SnippetButton = () => {
  const { showModal } = useModalContext();

  return (
    <Button
      data-test={'template-editor-snippets-button'}
      onClick={() =>
        showModal({
          modal: ContentModals.InsertSnippet,
          mediumDataKey: 'cannotInsert',
          mediumDataValue: '',
        })
      }
      size={BUTTON_SIZES.MEDIUM}
      variant={BUTTON_VARIANTS.SECONDARY}
    >
      <Snippet />
      <span>{displayContent.btnSnippet}</span>
    </Button>
  );
};

export default SnippetButton;
